import { env } from '../env';
export const isLocalEnv = env.REACT_APP_IS_LOCAL && env.REACT_APP_IS_LOCAL === 'true';
export const url = env.REACT_APP_API_URL;
export const urlV2 = env.REACT_APP_API_URL + '/v2';
export const aiPilotUrl = env.REACT_APP_AIPILOT_API_URL;
export const databricksurl = env.REACT_APP_API_URL + '/databricks/loginDatabricks';
export const portalUrl = env.REACT_APP_PORTAL_URL;
export const grafanaUrl = env.REACT_APP_GRAFANA_URL;
export const powerbiUrl = env.REACT_APP_POWERBIURL;
export const ctid = '42cc3295-cd0e-449c-b98e-5ce5b560c1d3';
export const platformCostObsDashboard = '/platformCostObs/dashboard';
export const teraDataDashboard = '/dashboard/business';
export const DataGrowthDashboard = '/dataGrowth/dashboard';
export const isEnvTypeLOCAL = env.REACT_APP_IS_LOCAL;
export const isEnvTypeDEV = env.REACT_APP_IS_DEV;
export const isEnvTypeUAT = env.REACT_APP_IS_QA;
export const isEnvTypePROD = env.REACT_APP_IS_PROD;
export const hideVV = env.REACT_APP_HIDE_VV === 'true';
export const hideCC = env.REACT_APP_HIDE_CC === 'true';
export const hideTeradata = env.REACT_APP_HIDE_TERADATA === 'true';
export const hideML = env.REACT_APP_HIDE_ML === 'true';
export const hideIBPExec = env.REACT_APP_HIDE_IBP_EXEC === 'true';
export const hideRMPlatformCost = env.REACT_APP_HIDE_RM_PLATFORM_COST === 'true';
export const hidePresto = env.REACT_APP_HIDE_PRESTO === 'true';
export const hideDMF = env.REACT_APP_HIDE_DMF === 'true';
export const snowUrl = env.REACT_APP_SNOW_URL;
export const hideMDIPExec = env.REACT_APP_HIDE_IBP_EXEC === 'true';
export const finopsRoutesPrivate = env.REACT_APP_FINOPS_ROUTES_PRIVATE === 'true';

export const hideDG = (moduleId = '') => {
	const hideAllDG = env.REACT_APP_HIDE_DG === 'true'
	const showAllDG = env.REACT_APP_ENABLED_DG_MODULES === 'all' && !hideAllDG
	if (moduleId === 'all') return !showAllDG

	const enabledModules = env.REACT_APP_ENABLED_DG_MODULES?.split(',') || []
	const showSomeModules = !hideAllDG && !!enabledModules?.length
	if (moduleId === 'some') return !showSomeModules

	const showCurrentModule = enabledModules?.includes(moduleId)
	const showModule = !!showAllDG || (!showAllDG && showCurrentModule)
	return !showModule
}


export const dashboardUrl = {
	administrator: `${grafanaUrl}/d/${env.REACT_APP_ADMINISTRATOR}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	operational: `${grafanaUrl}/d/${env.REACT_APP_OPERATIONAL}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	jobLineage: `${grafanaUrl}/d/${env.REACT_APP_JOBLINEAGE}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	jobExecAndSla: `${grafanaUrl}/d/${env.REACT_APP_JOBEXECANDSLA}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	jobPerformance: `${grafanaUrl}/d/${env.REACT_APP_JOBPERFORMANCE}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	executive: `${grafanaUrl}/d/${env.REACT_APP_EXECUTIVE}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	slaSeries: `${grafanaUrl}/d/${env.REACT_APP_SLASERIES}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	newJobSeries: `${grafanaUrl}/d/${env.REACT_APP_NEWJOBSERIES}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	reasonNotMet: `${grafanaUrl}/d/${env.REACT_APP_REASONNOTMET}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	jobRunHistory: `${grafanaUrl}/d/${env.REACT_APP_JOBRUNHISTORY}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	databricksSummary: `${grafanaUrl}/d/${env.REACT_APP_DATABRICKSSUMMARY}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	databricksgovernance: `${grafanaUrl}/d/${env.REACT_APP_DATABRICKSGOVERNANCE}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	dataBricksjobs: `${grafanaUrl}/d/${env.REACT_APP_DATABRICKSJOBS}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	dataBricksResourceOptimization: `${grafanaUrl}/d/${env.REACT_APP_DATABRICKSRESOURCEOPTIMIZATION}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	dataBricksCostSummary: `${grafanaUrl}/d/${env.REACT_APP_DATABRICKSCOSTSUMMARY}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	dataBricksTotalCostByWorkspace: `${grafanaUrl}/d/${env.REACT_APP_DATABRICKSTOTALCOSTBYWORKSPACE}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	grafanaFix: `${grafanaUrl}/d/${env.REACT_APP_GRAFANAFIX}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	tableausummary: `${grafanaUrl}/d/${env.REACT_APP_TABLEAUSUMMARY}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	powerbiCapability: env.REACT_APP_Capacity ? `${grafanaUrl}/d/${env.REACT_APP_Capacity}?orgId=1` : undefined,
	mlobsSummary: `${grafanaUrl}/d/${env.REACT_APP_ML_SUMMARY_DASHBOARD}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	mlobsFeatureDistribution: `${grafanaUrl}/d/${env.REACT_APP_ML_FEATURE_DISTRIBUTION}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	mlobsModelTargetDrift: `${grafanaUrl}/d/${env.REACT_APP_ML_TARGET_DRIFT}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	mlobsModelDataDrift: `${grafanaUrl}/d/${env.REACT_APP_ML_DATA_DRIFT}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	powerbiDataset: env.REACT_APP_DATASET ? `${grafanaUrl}/d/${env.REACT_APP_DATASET}?orgId=1` : undefined,
	controlMJobsInfrastructure: env.REACT_APP_CONTROLMJOBSINFRASTRUCTURE
		? `${grafanaUrl}/d/${env.REACT_APP_CONTROLMJOBSINFRASTRUCTURE}?orgId=1&kiosk`
		: undefined,
	autoSysJobsInfrastructure: env.REACT_APP_AUTOSYSJOBSINFRASTRUCTURE
		? `${grafanaUrl}/d/${env.REACT_APP_AUTOSYSJOBSINFRASTRUCTURE}?orgId=1&kiosk`
		: undefined,
	dmfHealthSummary: env.REACT_APP_HEALTHSUMMARY
		? `${grafanaUrl}/d/${env.REACT_APP_HEALTHSUMMARY}?orgId=1&kiosk`
		: undefined,
	dmfCatalogues: env.REACT_APP_CATALOGUES ? `${grafanaUrl}/d/${env.REACT_APP_CATALOGUES}?orgId=1&kiosk` : undefined,
	verificationValidationTableau: env.REACT_APP_TABLEAU ? `${grafanaUrl}/d/${env.REACT_APP_TABLEAU}?orgId=1` : undefined,
	tableauPerformance: `${grafanaUrl}/d/${env.REACT_APP_TABLEAUPERFORMANCE}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	tableauPerformanceExtract: `${grafanaUrl}/d/${env.REACT_APP_TABLEAUPERFORMANCEEXTRACT}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	tableauPerformanceCalendar: `${grafanaUrl}/d/${env.REACT_APP_TABLEAUPERFORMANCECALENDAR}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	tableauPerformanceJobsExecution: `${grafanaUrl}/d/${env.REACT_APP_TABLEAUPERFORMANCEJOBEXECUTION}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	tableauPerformanceJobSchedule: `${grafanaUrl}/d/${env.REACT_APP_TABLEAUPERFORMANCEJOBSCHEDULE}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	tableauPerformanceJobDetailView: `${grafanaUrl}/d/${env.REACT_APP_TABLEAUPERFORMANCEJOBDETAILSVIEW}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	tableauInfrastructure: env.REACT_APP_TABLEAUINFRASTRUCTURE
		? `${grafanaUrl}/d/${env.REACT_APP_TABLEAUINFRASTRUCTURE}?orgId=1&kiosk`
		: undefined,
	dataBricksjobsWorkspaceFailure: `${grafanaUrl}/d/${env.REACT_APP_DATABRICKSJOBSWORKSPACEFAILURE}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	dataBricksjobsClusterFailure: `${grafanaUrl}/d/${env.REACT_APP_DATABRICKSJOBSCLUSTERFAILURE}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	pcobsResourceMappingUrl: `${grafanaUrl}/d/${env.REACT_APP_PCOBS_RESOURCE_MAPPING}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	dataBricksCostSummaryWorkSpace: `${grafanaUrl}/d/${env.REACT_APP_DATABRICKSCOSTSUMMARYWORKSPACE}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	dataBricksCostSummaryCluster: `${grafanaUrl}/d/${env.REACT_APP_DATABRICKSCOSTSUMMARYCLUSTER}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	verificationValidationPowerBi: env.REACT_APP_VV_POWERBI
		? `${grafanaUrl}/d/${env.REACT_APP_VV_POWERBI}?orgId=1`
		: undefined,
	tableauGovernance: `${grafanaUrl}/d/${env.REACT_APP_TABLEAUGOVERNANCE}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	powerbiUsageGovernance: env.REACT_APP_POWERBI_USAGE_GOVERNANCE
		? `${grafanaUrl}/d/${env.REACT_APP_POWERBI_USAGE_GOVERNANCE}?orgId=1`
		: undefined,
	powerbiDataGrowthCost: env.REACT_APP_POWERBI_DATAGROWTH_COST
		? `${grafanaUrl}/d/${env.REACT_APP_POWERBI_DATAGROWTH_COST}?orgId=1`
		: undefined,
	tableauGovernanceMostUsedExtract: `${grafanaUrl}/d/${env.REACT_APP_TABLEAUGOVERNANCEMOSTUSEDEXTRACTS}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	tableauGovernanceMostUsedViews: `${grafanaUrl}/d/${env.REACT_APP_TABLEAUGOVERNANCEMOSTUSEDVIEWS}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	tableauGovernanceOrphaned: `${grafanaUrl}/d/${env.REACT_APP_TABLEAUGOVERNANCEORPHANED}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	tableauGovernanceUnusedExtracts: `${grafanaUrl}/d/${env.REACT_APP_TABLEAUGOVERNANCEUNUSEDEXTRACTS}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	dataGrowthTableauTotalCountOfExtracts: `${grafanaUrl}/d/${env.REACT_APP_DATAGROWTHTABLEAUTOTALCOUNTOFEXTRACTS}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	dataGrowthTableauTotalSizeOfExtract: `${grafanaUrl}/d/${env.REACT_APP_DATAGROWTHTABLEAUTOTALSIZEOFEXTRACT}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	dataGrowthTableauTotalCountOfDataSource: `${grafanaUrl}/d/${env.REACT_APP_DATAGROWTHTABLEAUTOTALCOUNTOFDATASOURCES}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	prestoDataGrowthofQueries: `${grafanaUrl}/d/${env.REACT_APP_PRESTODATAGROWTHOFQUERIES}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	prestoSummaryPanels: `${grafanaUrl}/d/${env.REACT_APP_PRESTOSUMMARYPANELS}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	prestoSummarySecondPanels: `${grafanaUrl}/d/${env.REACT_APP_PRESTOSUMMARYSECONDPANELS}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	powerbiInfrastructure: env.REACT_APP_POWERBIINFRASTRUCTURE
		? `${grafanaUrl}/d/${env.REACT_APP_POWERBIINFRASTRUCTURE}?orgId=1&kiosk`
		: undefined,
	dataGrowthDataBricksTotalCountOfTables: `${grafanaUrl}/d/${env.REACT_APP_DATAGROWTHDATABRICKSTOTALCOUNTOFTABLES}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	dataGrowthDataBricksTotalSizeOfTables: `${grafanaUrl}/d/${env.REACT_APP_DATAGROWTHDATABRICKSTOTALSIZEOFTABLES}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	controlsTestingDashboard: env.REACT_APP_CONTROLSTESTINGDASHBOARD
		? `${grafanaUrl}/d/${env.REACT_APP_CONTROLSTESTINGDASHBOARD}?orgId=1`
		: undefined,
	IBPDashboard: `${grafanaUrl}/d/${env.REACT_APP_IBP_TURKEY}?orgId=1&kiosk`,
	IBPCostService: `${grafanaUrl}/d/${env.REACT_APP_IBP_COST}?orgId=1&kiosk`,
	MDIPLandingPage: `${grafanaUrl}/d/${env.REACT_APP_MDIP_LANDING_PAGE}?orgId=1`,
	MDIPDetailedPage: `${grafanaUrl}/d/${env.REACT_APP_MDIP_DETAILED_PAGE}?orgId=1`,
	MDIPGoldPage: `${grafanaUrl}/d/${env.REACT_APP_MDIP_GOLD_PAGE}?orgId=1`,
	IBPGDOTimeseries: `${grafanaUrl}/d/${env.REACT_APP_IBP_GDO_TIMESERIES_BOARD_GLOBAL}?orgId=1`,
	IBPGDOActivityDetail: `${grafanaUrl}/d/${env.REACT_APP_IBP_GDO_ACTIVITY_DETAIL_GLOBAL}?orgId=1`,
	IBPGDOErrorBoard: `${grafanaUrl}/d/${env.REACT_APP_IBP_Error_Board_GLOBAL}?orgId=1`,
	IBPGDOIsoe: `${grafanaUrl}/d/${env.REACT_APP_IBP_ISOE_Board_GLOBAL}?orgId=1`,
	IBPGDOMainPage: `${grafanaUrl}/d/${env.REACT_APP_Main_Page_BOARD_GLOBAL}?orgId=1`,
	IBPGDOStatus: `${grafanaUrl}/d/${env.REACT_APP_GDO_Status_BOARD_GLOBAL}?orgId=1`,
	IBPGDOHomePage: `${grafanaUrl}/d/${env.REACT_APP_GDO_Home_Page_BOARD_GLOBAL}?orgId=1`,
	IBPServiceNow: `${grafanaUrl}/d/${env.REACT_APP_IBP_SERVICENOW}?orgId=1`,
	IBPMetric: `${grafanaUrl}/d/${env.REACT_APP_GDO_METERICS}?orgId=1`,
	IBPTurkeyGDOTimeseries: `${grafanaUrl}/d/${env.REACT_APP_IBP_TURKEY_GDO_TIMESERIES}?orgId=1`,
	MDIPVIETNAM: `${grafanaUrl}/d/${env.REACT_APP_MDIPVIETNAM}?orgId=1`,
	MDIPPMF: `${grafanaUrl}/d/${env.REACT_APP_MDIPPMF}?orgId=1`,
	MOSAIC: `${grafanaUrl}/d/${env.REACT_APP_MOSAIC}?orgId=1`,
	MDIPEXECUTIVE: `${grafanaUrl}/d/${env.REACT_APP_MDIPEXECUTIVE}?orgId=1`,
	MDIPMT2DC: `${grafanaUrl}/d/${env.REACT_APP_MDIPMT2DC}?orgId=1`,
	MDIPTAIWANGTMDETAILED: `${grafanaUrl}/d/${env.REACT_APP_TAIWAN_GTM_DETAILED}?orgId=1`,
	MDIPGeneralLanding: `${grafanaUrl}/d/${env.REACT_APP_GENERAL_MDIP_LANDING_PAGE}?orgId=1`,
	MosaicGeneralLanding: `${grafanaUrl}/d/${env.REACT_APP_GENERAL_MOSAIC_LANDING_PAGE}?orgId=1`,
	EDFGeneralLanding: `${grafanaUrl}/d/${env.REACT_APP_GENERAL_EDF_LANDING_PAGE}?orgId=1`,
};

export const pcobsDashboardUrl = {
	resourceMappingUrl: `${grafanaUrl}/d/${env.REACT_APP_PCOBS_RESOURCE_MAPPING_NEW}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`,
	resourceGroupDetailsUrl: `${grafanaUrl}/d/${env.REACT_APP_PCOBS_RESOURCE_GROUP_DETAILS}?orgId=1&kiosk&var-pepsicoUrl=${portalUrl}`
};
export const powerBIdashboardUrl = {
	PBNADashboard: `${powerbiUrl}/reportEmbed?reportId=${env.REACT_APP_PBNA_DASHBOARD}`,
	LATAMDashboard: `${powerbiUrl}/reportEmbed?reportId=${env.REACT_APP_LATAM_DASHBOARD}`,
	PFNADashboard: `${powerbiUrl}/reportEmbed?reportId=${env.REACT_APP_PFNA_DASHBOARD}`,
	CGFDashboard: `${powerbiUrl}/reportEmbed?reportId=${env.REACT_APP_CGF_DASHBOARD}`,
	AMESADashboard: `${powerbiUrl}/reportEmbed?reportId=${env.REACT_APP_AMESA_DASHBOARD}`,
	EUROPEDashboard: `${powerbiUrl}/reportEmbed?reportId=${env.REACT_APP_EUROPE_DASHBOARD}`,
	IBPBDRPowerBIDashboard: `${powerbiUrl}/reportEmbed?reportId=${env.REACT_APP_IBP_BDR_PBI}`,
	EPDashboard: `${powerbiUrl}/reportEmbed?reportId=${env.REACT_APP_ENTERPRISE_PLATFORM_DASHBOARD}`,
	NPIDashboard: `${powerbiUrl}/reportEmbed?reportId=${env.REACT_APP_NPI_DASHBOARD}`,
	DBODashboard: `${powerbiUrl}/reportEmbed?reportId=${env.REACT_APP_DBO_DASHBOARD}`,
	ITCDashboard: `${powerbiUrl}/reportEmbed?reportId=${env.REACT_APP_ITC_DASHBOARD}`,
	CostAnalysisDashboard: `${powerbiUrl}/reportEmbed?reportId=11969fc2-50de-45ea-b4ef-f854cf597bf7`,
	DBSQLCostAnalysisDashboard: `${powerbiUrl}/reportEmbed?reportId=9938d895-55a8-4448-a75d-d319a1d45234&reportCopilotInEmbed=true`,
	QueryLevelCostAnalysisDashboard: `${powerbiUrl}/reportEmbed?reportId=683ff374-acb5-453c-baa6-cd92b8a1d277&reportCopilotInEmbed=true`,
	ResourceUtilizationAnalysisDashboard: `${powerbiUrl}/reportEmbed?reportId=953b1e1f-1b48-46c8-b1ec-d81e86c64bea&reportCopilotInEmbed=true`,
	StandardizationMetricsDashboard: `${powerbiUrl}/reportEmbed?reportId=276e73c0-a96c-4cf0-a1d6-f42570c9d0a5&reportCopilotInEmbed=true`,
	VMDashboard: `${powerbiUrl}/reportEmbed?reportId=11969fc2-50de-45ea-b4ef-f854cf597bf7`, //&autoAuth=true&ctid=42cc3295-cd0e-449c-b98e-5ce5b560c1d3&actionBarEnabled=true&reportCopilotInEmbed=true`,
	ICEDQDashboard: `${powerbiUrl}/reportEmbed?reportId=47fe7b16-ef69-483c-87f8-8a8427808a6a`,
	BAICenterDashboard: `${powerbiUrl}/reportEmbed?reportId=61fbf619-6051-4bd2-812a-a00592481735&reportCopilotInEmbed=true`,
};
export const DataGrowthDashboardUrl = {
	AvgdatabasegrowthDashboard: `${powerbiUrl}/reportEmbed?reportId=${env.REACT_APP_AVG_DATABASE_GROWTH_DASHBOARD}`,
	TeradataProductionDashboard: `${powerbiUrl}/reportEmbed?reportId=${env.REACT_APP_TERADATA_PRODUCTION_DASHBOARD}`
};

export const FinopsDashboardUrl = {
	MBTDashboard: env.MBTPPTUrl
}
export const endpoints = {
	conversationalChat: '/sessions',
	login: '/user/login',
	userFeedback: '/pepwisev2/userFeedback',
	jobMapping: '/job/mapping',
	jobListing: '/job/list',
	jobListingFilter: '/job/listFilter',
	jobSearch: '/job/search',
	jobFilter: '/job/filter',
	jobOverview: '/job',
	jobUpdate: '/job/update',
	jobRunHistory: '/job/executions',
	jobDependencies: '/job/jobDependencies',
	jobRunUpdate: '/job/execution/update',
	jobExecutions: '/job/schedules',
	jobExecutionsFilter: '/job/schedulesFilter',
	jobFutureExecutions: '/job/futureSchedules',
	jobFutureExecutionsFilter: '/job/futureSchedulesFilter',
	jobExeActionTaken: '/dashboard/actionTakenData',
	jobRunSchedules: '/job/run/schedules',
	boxRunsList: '/job/box_list',
	jobExecutionsMetrices: '/job/schedules/metrics',
	sector: '/master/sectors',
	databricksSectors: '/databricks/sectorsLookup',
	workspaceList: '/databricks/workspacesLookup',
	system: '/master/systems',
	process: '/master/process',
	machines: '/master/machines',
	reports: '/job/report',
	// users: '/user/list',
	notificationAlerts: '/notification/alerts',
	business: '/dashboard/business',
	businessPiechart: '/dashboard/business/piechart',
	reasonsOfSla: '/master/slaNotMetReasons',
	processRuns: '/dashboard/business/processRuns',
	dailyCritical: '/dashboard/business/dailyCriticalPie',
	jobDependencyChart: '/job/jobDependencyChart',
	databricksSummary: '/databricks/summary/workspace',
	databricksWorkspaceSpent: '/databricks/costSummary/workspaceSpent',
	databricksProjectSpent: '/databricks/costSummary/projectSpent',
	databricksCPUUtilization: '/databricks/resourceOptimization/cpuUtil',
	databricksMemoryUtilization: '/databricks/resourceOptimization/memoryUtil',
	governanceStaleUsers: '/databricks/governance/staleUsers',
	governanceRunningJobs: '/databricks/governance/runningJobs',
	databricksJobs: '/databricks/jobs/runs',
	tableauWorkbooks: '/tableau/summary/workbooks',
	tableauUsers: '/tableau/summary/users',
	models: '/mlobs/models',
	model: '/mlobs/model',
	modelPerformanceMetric: '/mlobs/model/performanceMetric',
	modelfeatureDriftMetrics: '/mlobs/model/featureDriftMetric',
	tableauPerformance: '/tableau/performance/jobs',
	costSummaryGrafana: '/databricks/costSummary/cost',
	resourceGroups: '/pcobs/mapping/list',
	resourceGroup: '/pcobs/mapping',
	resourceGroupSectors: '/pcobs/sectors/list',
	resource: '/pcobs/resource',
	jobsGrafana: '/databricks/jobs/jobsChart',
	reasonChart: '/dashboard/business/slaNotMetReasonsChart',
	tableauPerformanceDrilldown: '/tableau/performance/extractTrendDetails',
	summaryGrafana: '/databricks/summary/summaryChart',
	resourceOptimizationGrafana: '/databricks/resourceOptimization/resourceOptimizationChart',
	governanceGrafana: '/databricks/governance/governanceChart',
	tableauGovernanceDetailView: '/tableau/governance/detailView',
	tableauGovernanceUsers: '/tableau/governance/users',
	tableauGovernanceOrphanUsers: '/tableau/governance/orphanUsersDetails',
	tableauGovernanceOrphanExtract: '/tableau/governance/orphanExtractsDetails',
	tableauGovernanceDrilldown: '/tableau/governance/unusedExtracts',
	tableauExtractFailureRuleDrilldown: '/rules/observations',
	prestoSummaryDrilldown: '/presto/tableDetails',
	sectorSql: '/master/sql_sectors',
	datagrowthDatabricksStorage: '/databricks/datagrowth/storageAccount',
	schedulers: '/master/schedulers',
	ibpJobListing: '/ibp/jobs',
	ibpJobRunsListing: '/ibp/ibpjobruns',
	ibpMonitorMetrics: '/ibp/metrics',
	ibpCostByService: '/ibpcost/costByService',
	ibpCostGrafana: '/ibpcost/detailedReactChart',
	biApplicationSummary: '/dataestate/biAppSummary',
	serviceRequestSummary: '/dataestate/serviceRequestSummary',
	annualSpendDataSourceIncidents: '/dataestate/annualSpendDataSourceIncidents',
	dataProcessingTrend: '/dataestate/getTrends',
	dataEstatePerformance: '/dataestate/getPerformance ',
	dataEstateSummary: '/dataestate/summary',
	synapseTime: '/dataestate/uptimeReliability',
	biApplicationTrend: '/dataestate/getTrends',
	deCostSummary: '/dataestate/costSummary',
	dataEstateOverallSummary: '/dataestate/overviewSummary',
	dataEstateExecutiveSummary: '/dataestate/executiveSummary',
	azureMonthlyCost: '/dataestate/azureMonthlyCost',
	deStorageSummary: '/dataestate/summary',
	deStorageTrends: '/dataestate/getTrends',
	queriesSummary: '/dataestate/queries',
	queriesTrends: '/dataestate/getTrends',
	chartData: '/dataestate/generateSLAChartData',
	incidentCriticalJobReport: '/dataestate/incidentCriticalJobsReport',
	incidentCriticalSlaReport: '/dataestate/incidentSlaReport',
	overviewSummaryMetrics: '/dataestate/overviewSummaryMetrics',
	summaryTable: '/dataestate/getKpiDetails',
	tableauSummary: '/dataestate/tableauSummary',
	databricksClusters: '/databricks/databricksClusters',
	finOpsOverviewSummary: '/finops/overviewSummary',
	finOpsProgramSummary: '/finops/programSummary',
	finOpsDetailSummary: '/finops/detailSummary',
	finOpsResourceDetail: '/finops/resourceDetail',
	finOpsCostKpi: '/finops/costKpi',
	lastSyncDate: '/dataestate/lastSyncDate',
	filterDetail: '/finops/filterDetail',
	finopsMappingList: '/finops/mappinglist',
	finopsExportMappingList: '/finops/exportMappinglist',
	finopsGetResource: '/finops/getResource',
	finopsResourceAllocation: '/finops/createAllocation',
	getFinopsResourceAllocation: '/finops/getAllocation',
	snowAssignmentGroups: '/dataops/getAssignmentGroups',
	addAssignmentGroup: '/dataops/addAssignmentGroup',
	updateAssignmentGroup: '/dataops/updateAssignmentGroup',
	deleteAssignmentGroup: '/dataops/deleteAssignmentGroup',
	finopsBulkEdit: '/finops/bulkupdate',
	finopsBulkEditInputSecEnvOptions: '/finops/getSectorsEnvList',
	getAllocationProgramPojects: '/finops/getProgramProject',
	finopsPlatformCostSummary: '/finops/getPlatformCostDetails',
	finopsCostBreakups: '/dataOps/getFinopsCostDetailsBreakups',
	finopsTotalCostDetails: '/dataOps/getFinopsCostDetails',
	crossEnvKPI: '/dataestate/crossEnvTableauKpis',
	dataPipelineSectorList: '/dataPipeline/sectors/list',
	pepwiseSectorList: '/pepwiseSectors/sectors/list',
	dataPipelineExecutiveDashboard: '/dataPipeline/executiveDashboard/',
	executiveProgramProjects: '/dataPipeline/executiveProgramProjects/',	bulkUploadEntities: '/datapipeline/gdo/bulk-update',
	bulkUploadLookups: '/bulkUploadLookup/lookups',
	getDependencyGraph: '/v2/datapipeline/dependency/graph',
	createProgram: '/dataPipeline/program/create',
	editProgram: '/dataPipeline/program/update',
	deleteProgram: '/dataPipeline/program/delete',
	createProject: '/dataPipeline/project/create',
	deleteProject: '/dataPipeline/project/delete',
	dataPipelineNewSectorList: '/dataPipeline/newSectors/list',
	e2eConfigurationMetadata: '/dataPipeline/exedashboard/configuration-metadata',
	deleteSchedule: '/dataPipeline/schedules/delete',
	editProject: '/dataPipeline/project/update',
	ProjectJobStatus: '/dataPipeline/teradata/ProjectJobStatus',
	ProjectJobStatusV2: '/dataPipeline/platform/projectJobStatus',
	exportProjectJobStatus: '/dataPipeline/exportProjectJobStatus',
	ProgramList: '/dataPipeline/teradata/ProgramList',
	SectorProgramMapping: '/dataPipeline/teradata/SectorProgramMapping',
	SectorProgramMappingIBP: '/dataPipeline/teradata/SectorProgramMappingIBP',
	PgmDetails: '/dataPipeline/teradata/PgmDetails',
	addNewPipelineParams: '/datapipeline/schedules/addUpdatePipelineParams',
	majorIncidentDetail: '/dataestate/majorIncidentLastMonth',
	incidentSummary: '/xopsCosmos/getIncidentsSummaryCosmos',
	incidentsByPrioritySummary: '/xopsCosmos/getSummaryMetricsIncidentsByPriorityTrendCosmos',
	incidentTechnologyList: '/xopsCosmos/getIncidentsTechnologyListCosmos',
	appProducts: '/xopsCosmos/getAppProducts',
	appProductsMetrics: '/xopsCosmos/getAppProductsMetrics',
	incidentTrend: '/xopsCosmos/getMetricsTrendCosmos',
	technologyListData: '/xopsCosmos/getMetricsCosmos',
	metricsTechnologyList: '/xopsCosmos/getMetricsTechnologyListCosmos',
	channelMetrics: '/xopsCosmos/getChannelMetricsCosmos',
	resolutionMetrics: '/xopsCosmos/getResolutionMetricsCosmos',
	L1toL3ResolutionMetrics: '/xopsCosmos/getResolutionLevelMetricsCosmos',
	incidentsBySector: '/xopsCosmos/getP3IncidentsSectorSummaryCosmos',
	mimsMetric: '/xopsCosmos/getMimsMetricsCosmos',
	mimsMetricTrend: '/xopsCosmos/getMimsMetricsTrendCosmos',
	happySignals: '/xopsCosmos/getHappySignalScore',
	happySignalsOverview: '/xopsCosmos/getHappySignalOverview',
	happySignalsSectors: '/xopsCosmos/getHappySignalSectors',
	happySignalsTechnology: '/xopsCosmos/getHappySignalTechnology',
	happySignalsTrends: '/xopsCosmos/getHappySignalsTrendsAndSummary',
	problemTicketsMetricTrend: '/xopsCosmos/getProblemTicketsMetricsTrendCosmos',
	problemTicketsMetric: '/xopsCosmos/getProblemTicketsMetricsCosmos',
	happySignalsPlatformList: '/dataOps/getHappySignalPlatformList',
	happySignalsCapabilityList: '/xopsCosmos/getHappySignalCapabilityList',
	happySignalsTechnologyList: '/xopsCosmos/getHappySignalTechnologyList',
	happySignalsOverviewTrend: '/xopsCosmos/getHappySignalOverviewTrend',
	p3IncidentsSummary: '/xopsCosmos/getP3IncidentsSummaryCosmos',
	getSummaryMessageDetails: '/dataOps/getSummaryMessageDetails',
	getSummaryMessageDetailsCosmos: '/xopsCosmos/getSummaryMessageDetailsCosmos',
	getKBArticlePublicationTrend: '/xopsCosmos/getKBArticlePublicationTrendCosmos',
	getSummaryMetricTrend: '/xopsCosmos/getSummaryMetricsTrendCosmos',
	getAllIncidentsTrend: '/xopsCosmos/getSummaryAllIncidentsTrendCosmos',
	getMonthlySummaryMetrics: '/xopsCosmos/getMonthlySummaryMetrics',
	getAllSummaryMetricTrend: '/xopsCosmos/getSummaryMetricsTrends',
	getUniqueMetadataFieldValues: '/xopsCosmos/getUniqueMetadataFieldValues',
	assignmentGroupListings: '/xopsCosmos/getAssignmentGroupListings',

	// export
	exportMajorIncidentDetail: '/dataestate/exportMajorIncidentLastMonth',
	teradataFolderNameList: '/dataPipeline/teradata/folderNameList',
	searchTeradataJobNameList: '/v2/datapipeline/Teradata/teradataNameList',
	getTeradataJobData: '/v2/datapipeline/Teradata/displayTeradataJobMetadata',
	getADFInstance: '/v2/datapipeline/ADF/adfNameList',
	getADBWorkspace: '/v2/datapipeline/ADB/searchADBWorkspace',
	searchADBJobNames: '/v2/datapipeline/ADB/searchADBWorkflowNameList',
	getADBJobData: '/v2/datapipeline/ADB/displayADBJobMetadata',
	searchADBGoldTableName: '/v2/datapipeline/ADB/searchADBGoldTableName',
	searchADFNames: '/v2/datapipeline/schedules/jobNameList',
	searchWindowsJobNames: '/v2/datapipeline/windows/searchWindowsJobNameList',
	searchSAPBWJobNames: '/v2/datapipeline/sapBw/searchSapBwJobNameList',
	getSAPBWJobData: '/v2/datapipeline/sapBw/displayJobMetadata',
	searchDDHJobNames: '/v2/datapipeline/DDH/searchDDHNameList',
	getDDHJobData: '/v2/datapipeline/DDH/displayDDHJobMetadata',
	searchMDTJobNames: '/v2/datapipeline/MDT/searchMDTNameList',
	getMDTJobData: '/v2/datapipeline/MDT/displayMDTJobMetadata',
	searchSqlAgentJobNames: '/v2/datapipeline/sql/searchSqlAgentJobNameList',
	getsqlAgentJobData: '/v2/datapipeline/sql/displaySqlAgentJobMetadata',
	searchIicsJobNames: '/v2/datapipeline/iics/searchIicsJobNameList',
	getIicsJobData: '/v2/datapipeline/iics/displayIicsJobMetadata',
	getwindowsJobData: '/v2/datapipeline/windows/displayJobMetadata',
	linkWinJobToProject: '/v2/datapipeline/windows/linkWinJobToProject',
	getAddedWinJobs: '/v2/datapipeline/windows/getAddedWinJobs',
	searchDataAsset: '/v2/datapipeline/ADF/searchDataAssetList',
  searchSilverTable: '/v2/datapipeline/ADF/searchSilverTableList',
	getScheduleExecutionsList: '/dataPipeline/schedules/teradataExe',
	exportgetScheduleExecutionsList: '/dataPipeline/schedules/exportTeradataExe',
	getOwnerList: '/dataPipeline/project/searchUser',
	getClarityProject: '/dataPipeline/project/loadClarityProject',
	dataPipelineProjectById: '/dataPipeline/project/details',
	customDashboard: '/dataPipeline/customDashboards',
	databricksClustersCount: '/dataestate/databricksClustersCount',
	dataPipelineProjectSlaMetrics: '/dataPipeline/schedules/getSlaMetrics',
	slaCountDetails: '/dataPipeline/schedules/slaCount',
	deleteScheduleFromProject: '/dataPipeline/schedules/deleteSchedules',
	finOpsExecutiveSummary: '/finops/executiveSummary',
	platformHealthSummary: '/dataOps/platformHealth/monitor',
	powerBICapacityMetrics: '/powerbi/capacities',
	powerBICapacityDetails: '/powerbi/capacityDetails',
	powerBICapacityDetailsPagination: '/powerbi/capacityDetailsPagination',
	powerBICapacityDetailsFilters: '/powerbi/capacityDetailsFilters',
	powerBIGatewayDetails: '/powerbi/gatewayDetails',
	powerBIGatewayMetrics: '/powerbi/gateway',
	powerBIGatewayVisualization: '/powerbi/gatewayVisualization',
	powerBIAdoptionMetrics: '/powerbi/adoption',
	powerBIgetSectors: '/powerbi/getSector',
	powerBICapacityStatus: '/powerbi/capacityStatus',
	powerBICUUtil: '/powerbi/cuUtilization',
	powerBIGatewayGrowth: '/powerbi/adoptionGatewayChart',
	powerBIReportGrowth: '/powerbi/adoptionReportChart',
	powerBIUserGrowth: '/powerbi/adoptionChart',
	powerBICapacitiesLastRefresh: '/powerbi/capacitiesLastRefresh',
	powerBICapacitiesGrowthLastRefresh: '/powerbi/capacitiesGrowthLastRefresh',
	powerBIGatewayGrowthLastRefresh: '/powerbi/gatewayGrowthLastRefresh',
	powerBIReportsGrowthLastRefresh: '/powerbi/reportsGrowthLastRefresh',
	powerBIUsersGrowthLastRefresh: '/powerbi/usersGrowthLastRefresh',
	powerBICapacityGrowth: '/powerbi/capacityGrowth',
	dpProjectKpiCount: '/dataPipeline/schedules/kpiData',
	getNormalCompletion: '/dataPipeline/schedules/normalCompletion',
	chartDataSla: '/dataestate/insertSla',
	getDatabricksClusterImpactDetails: '/dataestate/databricksClustersImpact',
	addedSchedulesList: '/dataPipeline/schedules/list',
	getAddedScheduleFilterColumn: '/dataPipeline/addedSchedules/filters/search',
	getdownTimeRequest: '/dataestate/downtimeRequest',
	teradataImpactDetails: '/dataestate/teradataImpactDetails',
	displayJobMetaData: '/dataPipeLine/schedules/displayJobMetaData',
	addSelectedJob: '/dataPipeLine/schedules/addSelectedJob',
	displaySelectedJob: '/dataPipeLine/schedules/displaySelectedJob',
	displayAddedJobs: '/dataPipeLine/teradata/displayAddedJobs',
	getAllDependentJobs: '/dataPipeLine/teradata/getAllDependent',
	bulkJobDelete: '/dataPipeLine/schedules/bulkJobDelete',
	dataEstateJobPerformance: '/dataestate/teradataJobPerformance',
	depJobExeData: '/dataPipeline/depJob/executions',
	depJobExeDataV2: '/dataPipeline/job/lineage',
	cyclicExeData: '/dataPipeline/teradataExe/cyclicExe',
	slaHistoryData: '/dataPipeline/project/sla/logs',
	dataestateSectorDetails: '/dataestate/sectorList',
	kpiFrameworkConfigList: '/kpiFramework/configList',
	kpiFrameworkIngestList: '/kpiFramework/ingestList',
	addProgram: '/finOps/createProgram',
	getPrograms: '/finOps/getProgram',
	addProject: '/finOps/createProject',
	getProgramDetailsById: '/finOps/getProgramDetails',
	getProjectListByProgramId: '/finOps/getProject',
	exportProjectListByProgramId: '/finOps/exportGetProject',
	editProgramDetails: '/finOps/editProgram',
	deleteProgramDetails: '/finOps/deleteProgram',
	editProjectDetails: '/finOps/editProject',
	deleteProjectDetails: '/finOps/deleteProject',
	getProjectDetailsById: '/finOps/getProjectDetails',
	getAllocation: '/finOps/getAllocation',
	copyProjectToProgram: '/finOps/copyProjectToProgram',
	jobUploadDp: '/dataPipeline/jobBulkUpload',
	alertFrameworkConfig: '/alertFramework/configs',

	uploadJobMetadata: '/datapipeline/job-metadata/upload',
	JobMetaDataTable: '/datapipeline/job-metadata/tabledata',
	JobMetaDataFilterOptions: '/datapipeline/job-metadata/filter-options',
	JobMetaDataExport: '/datapipeline/job-metadata/export',
	JobMetaDataFields: '/datapipeline/job-metadata/fields',
	postComment: '/dataPipeline/teradataExe/jobExe/comment',
	getExecutiveStatusData: '/dataPipeline/dp/executive',
	getContactDetails: '/dataPipeline/dp/contactDetails',
	addOrUpdateInsight: '/dataOps/addOrUpdateInsight',
	getInsights: '/dataOps/getInsightList',
	deleteInsights: '/dataOps/deleteInsight',
	finopsPPTEmbedUrl: '/dataOps/getFinopsPPTEmbedUrl',
	dataEstateDataProcessingSummary: '/dataestate/dataProcessingSummary',
	getExecutiveDashboardData: '/dataPipeline/exedashboard/data',
	getExecutiveProjData: '/dataPipeline/exedashboard/data/project',
	saveSearchedQuery: '/finOps/saveSearchedQuery',
	getSavedQueryList: '/finOps/getSavedQueryList',
	deleteSavedQueryDetails: '/finOps/deleteSavedQuery',
	editQueryDetails: '/finOps/editQueryDetails',
	dataestateKpiSectorDetails: '/dataestate/kpiSectorList',
	finopsBulkEditInputPrgmProjOptions: '/finops/getProgram',
	fetchCopyProject: '/finOps/copyProject',
	fetchStorageGrowthTrend: '/dataGrowth/getStorageGrowthTrend',
	fetchContainerGrowthTrend: '/dataGrowth/getContainerGrowthTrend',
	fetchTopStorageAccounts: '/dataGrowth/getTopStorageAccounts',
	fetchProjectOptions: '/dataGrowth/getProjects',
	fetchStorageAccountOptions: '/dataGrowth/getStorageAccounts',
	fetchStorageAccountsDetails: '/dataGrowth/getStorageAccountsDetails',
	fetchConatinerOptions: '/dataGrowth/getContainers',
	fetchTopContainers: '/dataGrowth/getTopContainers',
	fetchTopLevelFolders: '/dataGrowth/getTopLevelFolders',
	fetchTopStorageAccountsList: '/dataGrowth/getTopStorageAccountsList',
	exportTopStorageAccountsList: '/dataGrowth/exportTopStorageAccounts',
	fetchStorageBySector: '/dataGrowth/getStorageBySector',
	fetchExecutiveProgramProjects: '/dataPipeline/executiveProgramProjects/read',
	deleteExecutiveProgram: '/dataPipeline/executiveProgramProjects/delete/program',
	updateExecutiveProgram: '/dataPipeline/executiveProgramProjects/update',
	deBiAppUserTrend: '/dataestate/powerBiUserGrowthChart',
	dePowerBIDatasetData: '/dataestate/powerBiDatasetData',
	dePowerBIUserAndReport: '/dataestate/powerBIUserAndReportData',
	// export service
	genericExport: '/finOps/exportTableData',
	powerBIActivityDetails: '/powerbi/activityDetails',
	powerBIActivityDetailsPagination: '/powerbi/activityDetailsPagination',
	powerBIActivityDetailsFilters: '/powerbi/activityDetailsFilters',
	powerBIgetCapacityName: '/powerbi/getCapacityName',

	//databricksObservability
	databricksObservabilityClusterSpend: '/databricksObservability/workspace/clusterSpend',
	runClusterCount: '/databricksObservability/workspace/runningClusters',
	scheduleCount: '/databricksObservability/workspace/cronJobs',
	clusterCountType: '/databricksObservability/workspace/clusterCountByType',
	clusterSpendByWorkspace: '/databricksObservability/workspace/spendByWorkspace',
	nodeTypeDistribution: '/databricksObservability/workspace/nodeTypeDistribution',
	computeTypeByWorkspace: '/databricksObservability/workspace/computeTime',
	azuregetSectors: '/dataGrowth/getSector',
	jobStatusDistribution: '/databricksObservability/job/jobStatus',
	jobRunSuccessVsFail: '/databricksObservability/job/successvsfail',
	jobCost: '/databricksObservability/job/costs',
	totalJobsByWorkspace: '/databricksObservability/job/totalJobsByWorkspace',
	avgFailureWorkspace: '/databricksObservability/job/avgFailureTime',
	interactiveCluster: '/databricksObservability/job/jobRunningWorkspaces',
	spendByCategory: '/databricksObservability/cluster/spendByCategory',
	withoutAutoTermination: '/databricksObservability/cluster/spendByWithoutAutoTermination',
	autoTermination: '/databricksObservability/cluster/autoTerminationPrctSpend',
	clusterCount: '/databricksObservability/cluster/clusterCount',
	overviewSummaryCost: '/dataestate/overviewSummaryCost',


	// adb_workspace_metrics
	overallCost: '/databricksObservability/workspace/overAllCost',
	overAllDbuCount: '/databricksObservability/workspace/dbuCount',
	databricksObservabilityactiveWorkspaces: '/databricksObservability/workspace/activeWorkspaces',
	workspaceSpend: '/databricksObservability/workspace/topSpendWorkspace',
	costType: '/databricksObservability/workspace/costByType',
	countType: '/databricksObservability/workspace/countByType',
	workspaceRunTime: '/databricksObservability/workspace/topRuntimeWorkspace',
	costDate: '/databricksObservability/workspace/costByTime',
	countDate: '/databricksObservability/workspace/countByTime',
	lastSync: '/databricksObservability/workspace/lastFetch',
	getEnv: '/databricksObservability/workspace/getEnv',
	overAllCostYTD: '/databricksObservability/workspace/overAllCostYTD',
	overAllCostTree: '/databricksObservability/workspace/overAllCostTree',
	overAllCostData: '/databricksObservability/workspace/overAllCostData',
	runTimeByWorkspace: '/databricksObservability/workspace/runTimeByWorkspace',
	workspaceWithRunTimeTable: '/databricksObservability/workspace/detailedComputeDetailsData',
	activeWorkspacesTable: '/databricksObservability/workspace/activeWorkspacesData',
	totalDBU: '/databricksObservability/workspace/TotalDBU',
	DBUFilterOptions: '/databricksObservability/workspace/DBUFilterOptions',
	fetchDBUDataWithFilters: '/databricksObservability/workspace/fetchDBUDataWithFilters',
	detailedComputeCostByType: '/databricksObservability/workspace/detailedComputeCostByType',
	detailedComputeCountByType: '/databricksObservability/workspace/detailedComputeCountByType',
	detailedComputeDetailsData: '/databricksObservability/workspace/detailedComputeDetailsData',
	newClusterByCategoryAggregate: '/databricksObservability/cluster/NewClusterByCategoryAggregate',
	fetchClusterSpinUpsByCategoryAggregate: '/databricksObservability/cluster/fetchClusterSpinUpsByCategoryAggregate',
	newClusterByCategoryData: '/databricksObservability/cluster/NewClusterByCategoryData',
	workspaceOptions: '/databricksObservability/phaseTwo/onlyWorkspaces',
	fetchClusterSpinUpsByCategoryData: '/databricksObservability/cluster/fetchClusterSpinUpsByCategoryData',
	fetchClusterDetails: '/databricksObservability/cluster/fetchClusterDetails',
	fetchClusterNameBasedOnWorkspace: '/databricksObservability/cluster/fetchClusterNameBasedOnWorkspace',
	fetchTopSpendingTreeData: '/databricksObservability/workspace/topSpendingTreeData',
	fetchRunTimeTreeData: '/databricksObservability/workspace/runTimeTreeData',
	fetchAggregateClusterDataByDate: '/databricksObservability/cluster/fetchAggregateClusterDataByDate',
	sectorLookup: '/databricksObservability/workspace/sectors',
	// ADB Cluster_Analytics
	countByCategory: '/databricksObservability/cluster/countByType',
	spentByCategory: '/databricksObservability/cluster/spendByType',
	costByCluster: '/databricksObservability/cluster/spendWithoutAutoTermByType',
	withoutAutoTermcountType: '/databricksObservability/cluster/interactiveCOunt',
	clusterSpinsUp: '/databricksObservability/cluster/spinCountByType',
	computeJob: '/databricksObservability/cluster/topJobSpend',
	computeInteractive: '/databricksObservability/cluster/topInteractiveSpend',
	clusterLastSync: '/databricksObservability/cluster/lastFetch',

	//ADB Job_Analysis
	failureReason: '/databricksObservability/job/topFailureReasons',
	statusOverview: '/databricksObservability/job/statusOverview',
	expensiveFailure: '/databricksObservability/job/expensiveFailure',
	expensiveFailureCost: '/databricksObservability/job/expensiveFailureCost',
	jobLastSync: '/databricksObservability/job/lastFetch',
	expensiveSuccess: '/databricksObservability/job/expensiveSuccess',
	onlyWorkspaces: '/databricksObservability/phaseTwo/onlyWorkspaces',
	totalFailedJobCost: '/databricksObservability/job/totalFailedJobCost',
	totalFailedJobCostDetailedData: '/databricksObservability/job/totalFailedJobCostDetailedData',
	statusTreeData: '/databricksObservability/job/statusTreeData',
	statusDetailedData: '/databricksObservability/job/statusDetailedData',
	failureReasonsTreeData: '/databricksObservability/job/failureReasonsTreeData',
	failureReasonsDetailedData: '/databricksObservability/job/failureReasonsDetailedData',

	//ADB Job_Analysis - Peak_Hours
	peakHour: '/databricksObservability/job/peakHour',
	activeWorkspace: '/databricksObservability/job/activeWorkspace',
	hourByJobCount: '/databricksObservability/job/hourByJobCount',
	topWorkspaces: '/databricksObservability/job/topWorkspaces',
	peakHourDetailedData: '/databricksObservability/job/peakHourDetailedData',
	peakHourTreeData: '/databricksObservability/job/peakHourTreeData',

	//DBUSQL_Dashboard
	totalSql: '/databricksObservability/sql/totalWarehouses',
	totalCost: '/databricksObservability/sql/totalCost',
	newWarehouse: '/databricksObservability/sql/newWarehouses',
	costTrend: '/databricksObservability/sql/costTrendSeggregation',
	topDBU: '/databricksObservability/sql/topDbus',
	topCost: '/databricksObservability/sql/topCosts',
	lonRun: '/databricksObservability/sql/longRun',
	failedMetrics: '/databricksObservability/sql/failedMetrics',
	peakCount: '/databricksObservability/sql/peakCount',
	queryTrend: '/databricksObservability/sql/queryTrend',
	topGroupDbu: '/databricksObservability/sql/topGroupDbu',
	topGroupCost: '/databricksObservability/sql/topGroupCost',
	topUsageCatalogs: '/databricksObservability/sql/topUsageCatalogs',
	topUsageCatlgsCost: '/databricksObservability/sql/topUsageCatalogsCost',
	sqllastFetch: '/databricksObservability/sql/lastFetch',
	countByCategoryTreeData: '/databricksObservability/sql/countByCategoryTreeData',
	countByCategoryDetailedData: '/databricksObservability/sql/countByCategoryDetailedData',
	costByCategoryTreeData: '/databricksObservability/sql/costByCategoryTreeData',
	costByCategoryDetailedData: '/databricksObservability/sql/costByCategoryDetailedData',
	newCountByCategoryTreeData: '/databricksObservability/sql/newCountByCategoryTreeData',
	newCountByCategoryDetailedData: '/databricksObservability/sql/newCountByCategoryDetailedData',
	queryTrendTreeData: '/databricksObservability/sql/queryTrendTreeData',
	dbuByWarehouseTreeData: '/databricksObservability/sql/dbuByWarehouseTreeData',
	dbuGroupTreeData: '/databricksObservability/sql/dbuGroupTreeData',
	costGroupTreeData: '/databricksObservability/sql/costGroupTreeData',
	queryTrendDetailedData: '/databricksObservability/sql/queryTrendDetailedData',
	dbuGroupDetailedData: '/databricksObservability/sql/dbuGroupDetailedData',
	catalogCountTreeData: '/databricksObservability/sql/catalogCountTreeData',
	catalogCostTreeData: '/databricksObservability/sql/catalogCostTreeData',
	catalogDetailedData: '/databricksObservability/sql/catalogDetailedData',
	failedQueryCostTreeData: '/databricksObservability/sql/failedQueryCostTreeData',
	failedQueryDetailedData: '/databricksObservability/sql/failedQueryDetailedData',
	peakQueryDetailedData: '/databricksObservability/sql/peakQueryDetailedData',

	//Custom_Analysis_Dashboard
	starterWarehouses: '/databricksObservability/custom/starterWarehouses',
	starterWarehouseList: '/databricksObservability/custom/starterWarehouseList',
	maxAutoTerm: '/databricksObservability/custom/maxAutoTerm',
	autoTermDetails: '/databricksObservability/custom/maxAutoTermDetails',
	longRun: '/databricksObservability/custom/longRun',
	longRunDetails: '/databricksObservability/custom/longRunDetails',
	customlastFetch: '/databricksObservability/custom/lastFetch',
	overProvision: '/databricksObservability/custom/overProvision',
	untagggedCost: '/databricksObservability/custom/untagggedCost',
	dbrVersion: '/databricksObservability/custom/dbrVersion',
	overProvisionList: '/databricksObservability/custom/overProvisionList',
	untaggedList: '/databricksObservability/custom/untaggedList',
	dbrVersionList: '/databricksObservability/custom/dbrVersionList',
	customConfigList: '/databricksObservability/custom/config',
	eodSupport: '/databricksObservability/custom/eodsupport',
	stableDBR: '/databricksObservability/custom/stableDBR',

	//PowerBI Reports APIs
	powerBIReportsKPI: '/powerBI/powerBIReportAPI/kpiCards',
	powerBIReportsDetails: '/powerBI/powerBIReportAPI/tableData',
	powerBIReportsGrowth: '/powerBI/powerBIReportAPI/reportGrowth',
	powerBIReportsUsage: '/powerBI/powerBIReportAPI/reportUsage',
	powerBIReportActivityDetailsExport: '/powerBI/powerBIReportAPI/exportReportActivityDetails',


	//PowerBI Capacity APIs
	powerBICapacityKPI: '/powerBI/powerBICapacityAPI/CapacitykpiCards',
	powerBICapacityGrowthData: '/powerBI/powerBICapacityAPI/CapacityGrowth',
	powerBICapacityData: '/powerBI/powerBICapacityAPI/CapacityData',
	powerBICapacityReportData: '/powerBI/powerBICapacityAPI/CapacityExportData',
	powerBICapacityList: '/powerBI/powerBICapacityAPI/CapacityNames',

	// PowerBI User APIs
	powerBiUserActivityDetailsExport: '/powerbi/userActivity/exportUserActivityDetails',

	// Tableau License APIs
	tableauTotalLicenses: '/tableau/totalLicenses',
	tableauLicenseUtilization: '/tableau/licenseUtilization',
	tableauLicenseUtilizationKpi: '/tableau/licenseUtilizationKpi',
	tableauLicenseTrendChart: '/tableau/tableauActivityTrend',
	tableauLicenseExportActivity: '/tableau/licenseUtilizationExport',
	tableauTotalReports: '/tableau/totalReports',
	tableauReportUsage: '/tableau/reportUsage',
	tableauTopPublisher: '/tableau/topReportPublisher',
	tableauReportsTrend: '/tableau/reportTrends',
	tableauTotalCost: '/tableau/totalCost',
	tableauCostByRole: '/tableau/costByRole',
	tableauCostBySector: '/tableau/costBySector',
	tableauCostExport: '/tableau/costExport',

	// Resource Mapping
	resourceCostSummaryKpi: '/finops/costSummaryKpi',
	resourceCostSummaryExport: '/finops/exportCostSummary',

	// FinOps Executive
	finopsExecutiveSummary: '/finopsExecutive/summary',
	finopsExecutivePrograms: '/finopsExecutive/programs',
	finopsExecutiveSectors: '/finopsExecutive/sectors',
	finopsExecutivePlatforms: '/finopsExecutive/platforms',
	finopsExecutiveSpendingByType: '/finopsExecutive/spending-by-type',
	finopsExecutiveChartSeries: '/finopsExecutive/chart-series',
	finopsExecutiveTrendIncrement: '/finopsExecutive/trend-increment',
	finopsExecutiveAddOrUpdateInsight: '/finopsExecutive/addOrUpdateInsight',
	finopsExecutiveDeleteInsight: '/finopsExecutive/deleteInsight',
	finopsExecutiveGetInsights: '/finopsExecutive/getInsightList',

	// credential management
	getCredentials: '/credentials',

	//product catalog
	productCatalogOverview: '/productCatalog/overview',
	upcomingRenewals: '/productCatalog/upcoming-renewals',
	expiredContracts: '/productCatalog/expired-contracts',
	upcomingRenewalsTable: '/productCatalog/renewals/table',
	upcomingRenewalsFilter: '/productCatalog/renewals/filters',
	upcomingCategoryCounts: '/productCatalog/renewals/counts',
	upcomingRenewalsExport: '/productCatalog/renewals/export',
	budgetVariance: '/productCatalog/budgetVariance',
	renewalCost: '/productCatalog/renewalCost',
	totalCurrentSpend: '/productCatalog/totalCurrentSpend',
	billingCycleDistribution: '/productCatalog/billingCycleDistribution',
	renewalsByOwner: '/productCatalog/renewalsByOwner/export',
	dataQualityAndRiskKpis: '/productCatalog/DQ&RKpis',
	catalogueDataCompleteness: '/productCatalog/catalogueDataCompleteness',
	dataQualityBreakDown: '/productCatalog/dataQualityBreakDown',
	catalogProductDetails: '/productCatalog/product',
	missingDetails: '/productCatalog/missingTableData',
	exportMissingData: '/productCatalog/exportMissingData',

	// product success
	getUserRoleUsageTrend: '/productSuccess/userRoleUsageTrends',
	getUserAvgTimeInPlatform: '/productSuccess/avgTimeInPlatform',
	getUserAdoptionRate: '/productSuccess/adoptionRate',
	getMostVisitedPage: '/productSuccess/mostVistedPages',

	// Pipeline Run Status
	filterDetails: '/dataops/pipelineStatus/advanceFilter',
	summaryData: '/dataops/pipelineStatus/runStatusKpi',
	scheduleKpiData: '/dataops/pipelineStatus/runStatusScheduleKpi',
	customStatusKpiData: '/dataops/pipelineStatus/runCustomStatusKpi',
	jobsList: '/dataops/pipelineStatus/pipelineMasterData',
	jobsListScheduled: '/dataops/pipelineStatus/pipelineScheduleData',
	exportCount: '/dataops/pipelineStatus/exportCount',
	jobsListExport: '/dataops/pipelineStatus/exportPipelineStatusDetail',
	jobsListScheduledExport: '/dataops/pipelineStatus/exportScheduledStatusDetail',
	runDistribution: '/dataops/pipelineStatus/runDistribution',
	runTrend: '/dataOps/pipelineStatus/runTrend',
	runTrendAvg: '/dataOps/pipelineStatus/runTrendAvg',
	jobStatusbyType: '/dataOps/pipelineStatus/jobStatusbyType',
	jobScheduleByHour: '/dataOps/pipelineStatus/jobScheduleByHour',
	pipelineGroupByChildren: '/dataops/pipelineStatus/PipelineGroupChildren',
	platformHealthGroupChildren: '/dataOps/platformHealth/PlatformGroupChildren',
	platformHealthColumnFilter: '/dataOps/platformHealth/columnFilter',
	crossflowData: '/dataPipeline/crossflow/data',
	jobListSlaConfig: '/dataPipeline/project/listSlaConfig',
	saveJobSlaConfig: '/dataPipeline/project/saveSlaConfig',
	deleteJobSlaConfig: '/dataPipeline/project/deleteSlaConfig',
	cloudSpendTotalByService: '/finopsExecutive/cloud-spend/total-by-service',
	cloudSpendServiceCostByMonth: '/finopsExecutive/cloud-spend/service-cost-by-month',
	cloudSpendFilters: '/finopsExecutive/cloud-spend/filters',
	ProgramCostTrendTable: '/finopsExecutive/cloud-spend/program-cost-trend-table',
	ProgramCostLine: '/finopsExecutive/cloud-spend/program-cost-line',
	ServiceCostTable: '/finopsExecutive/cloud-spend/service-cost-table',
	EnvCostPie: '/finopsExecutive/cloud-spend/env-cost-pie',
	ConsumptionMetricTable: '/finopsExecutive/cloud-spend/consumption-metric-table',
	CostAvoidanceTable: '/finopsExecutive/cloud-spend/cost-avoidance-table',
	PreAopCostSummaryTable: '/finopsExecutive/cloud-spend/preaop-cost-summary-table',
	PreAopConsumptionMetricsTable: '/finopsExecutive/cloud-spend/preaop-consumption-metrics-table',
	PreAopDetailsTable: '/finopsExecutive/cloud-spend/preaop-details-table',
	dissectionTable: '/finopsExecutive/cloud-spend/dissection-table',
	edfBenefitsTable: '/finopsExecutive/cloud-spend/edf-benefits-table',
	edfCatalogingTable: '/finopsExecutive/cloud-spend/edf-cataloging-table',
	edfCostOverviewTable: '/finopsExecutive/cloud-spend/edf-cost-overview-table',
	edfHeatMapTable: '/finopsExecutive/cloud-spend/edf-heatmap-table',
	edfPriorityMarketsTable: '/finopsExecutive/cloud-spend/edf-priority-markets-table',


	// IBP
	ibpAdvanceFilters: '/dataPipeline/ibp/advanceFilters',
	ibpGdoList: '/dataPipeline/ibp/gdoList',
	activeIbpGdoList: '/dataPipeline/ibp/gdo/list',
	ibpGdoListExport: '/dataPipeline/ibp/gdoList/export',
	ibpGdoKpi: '/dataPipeline/ibp/gdoKpi',
	ibpStageList: '/dataPipeline/ibp/stageList',
	ibpStageListExport: '/dataPipeline/ibp/stageList/export',
	ibpStageEdit: '/dataPipeline/ibp/stage/edit',
	ibpStageKpi: '/dataPipeline/ibp/stageKpi',
	ibpJobExecution: '/dataPipeline/ibp/jobExecution',
	ibpJobExecutionExport: '/dataPipeline/ibp/jobExecution/export',
	ibpAlertProgramHierarchy: '/dataPipeline/ibp/alerts/programConfig',
	ibpGdoInfo: '/dataPipeline/ibp/gdo/info',
	ibpGdoEdit: '/dataPipeline/ibp/gdo/edit',
	ibpGdoDelete: '/datapipeline/ibp/gdo/delete',
	ibpGdoAddPipelines: '/dataPipeline/ibp/gdo/addPipelines',
	ibpGdoDeletePipelines: '/dataPipeline/ibp/gdo/deletePipelines',
	addProgramDependency: '/datapipeline/dependency/add',
	removeProgramDependency: '/datapipeline/dependency/remove',

	// XOps Intelligence
	xopsIntelligenceDashboards: '/xopsIntelligence/dashboards',

	//E2E
	dataPipelineE2EFilterDetails: '/dataPipeline/e2e/advanceFilter',

	//PepIris
	dataReconciliation: '/dataPipeline/dataReconciliation',
	dataReconciliationExport: '/dataPipeline/exportDataReconciliation',

	//Banner
	bannerDetails: '/banner/getBanner',
};
